export enum RecordState {
  Active = 'Active',
  Draft = 'Draft',
  Outdated = 'Outdated',
  Irrelevant = 'Irrelevant'
}
